<script>
  import { scaleBand, scaleLinear, scaleTime, scaleOrdinal, scaleSequential} from 'd3-scale'
  import { timeMonth } from "d3-time"
  import { schemePastel2, schemeSet3, interpolateOranges } from 'd3-scale-chromatic'
  import { reviewsCleaned } from './reviews.js'
  import { airbnb } from "./airbnb.js";
  import { plnAreas } from "./planning_areas.js";
  import { listings_by_duration } from "./listing_duration.js";
  import { airbnb_area } from "./airbnb_area_join.js";
  import { Graphic, Section, Point, PolygonLayer, Rectangle, createGeoScales, RectangleLayer, XAxis, YAxis, Label, Title, DiscreteLegend, GradientLegend, Polygon } from '@snlab/florence'
  import DataContainer from '@snlab/florence-datacontainer'

  // overall settings
  const padding = {left: 50, bottom: 50, top: 50, right: 40};

  //Reviews 
  
  let reviewsRaw = new DataContainer(reviewsCleaned).mutate({
    date: row => new Date(row.date_year_month)
  }).mutate({year: row => row.date_year_month.substring(0, 4)})

  let reviews = reviewsRaw

  console.log(reviewsRaw);

  //Formatting

  const colorBar = "rgb(255, 88, 93)"
  
  //Interactivity over bars

  let selectedBar = ""

  $: selectedBarInfo = reviews.row(selectedBar)

  function handleMouseover (event) {
    selectedBar = event.key
    }

    function handleMouseout (event) {
    selectedBar = ''
    }

  //Interactivity dropdown box

  let reviewsAcrossYearsCount = reviews
    .mutate({year: row => row.date_year_month.substring(0, 4)})
    .groupBy("year")
    .summarise({ reviews_year: { count: "sum" } })
  
  console.log(reviewsAcrossYearsCount)

  let reviewsAcrossYears = reviews
    .mutate({year: row => row.date_year_month.substring(0, 4)})

  console.log(reviewsAcrossYears)

  const reviewsYears = reviews.domain('year') //find domain of categorical variable town and sort in ascending order
  reviewsYears.unshift('ALL YEARS')
  let selectedYear = 'ALL YEARS'
  
  $: {
    if (selectedYear === "ALL YEARS") {
      reviews = reviewsRaw
    }
    else {
    reviews = reviewsRaw.filter(row => row.year === selectedYear)
    }
  }

  // Map showing points

  // airbnb data
  const airbnbRaw = new DataContainer(airbnb);
  let listings = airbnbRaw;

  const planningAreas = new DataContainer(plnAreas);

  // set up scales
  // 1. position
  const myGeoScale = createGeoScales(planningAreas.domain("$geometry"));

  // 2. color
  const myColorScale = scaleOrdinal()
    .domain(planningAreas.domain("REGION_N"))
    .range(schemeSet3);

  // to replace with mouseover func for tooltip

  let selectedListing = "";
  let mousePosition = undefined;

  function handleMouseoverPointListings(event, row) {
    selectedListing = {
      proptype: row.property_type,
      roomtype: row.room_type
    };

    mousePosition = {
      x: event.localCoordinates.x,
      y: event.localCoordinates.y
    };
  }

  function handleMouseoutPointListings(event, row) {
    selectedListing = "";
    mousePosition = undefined;
  }

  // town selection
  const towns = listings.domain("planning_area").sort(); //default sort by ascending order
  towns.unshift("ALL TOWNS");
  let selectedTown = "ALL TOWNS";

  $: {
    if (selectedTown === "ALL TOWNS") {
      listings = airbnbRaw;
    } else {
      listings = airbnbRaw.filter(row => row.planning_area === selectedTown);
    }
  }

  // Map showing aggregated data

  // loading listings data
  const listingsAreaRaw = new DataContainer(airbnb_area);
  let listingsArea = listingsAreaRaw;
  
  console.log(listingsArea);

  const listingsAreaWithoutNull = listingsArea.filter(row => row.num_listings !== null)
  const listingsAreaNull = listingsArea.filter(row => row.num_listings === null)

  console.log(listingsAreaWithoutNull)

  // set up scales
  // 1. position
  const myGeoScaleArea = createGeoScales(planningAreas.domain("$geometry"));

  // 2. fill color
  const myColorScaleArea = scaleSequential()
    .domain(listingsArea.domain('num_listings'))
    .interpolator(interpolateOranges)

  //Interactivity
  let selectedListingArea = "";
  let mousePositionArea = undefined;

  function handleMouseoverArea(event, row) {
    selectedListingArea = {
      listings_number: row.num_listings,
      planning_area: row.PLN_AREA_N
    };

    mousePositionArea = {
      x: event.localCoordinates.x,
      y: event.localCoordinates.y
    };
  }

  function handleMouseoutArea(event, row) {
    selectedListingArea = "";
    mousePositionArea = undefined;
  }

  // Map showing min stated stay

  // loading listings data
  const durationRaw = new DataContainer(listings_by_duration);
  let listingsDuration = durationRaw;
  var stated_min_duration = [
    "One week or less",
    "8 to 14 days",
    "15 to 21 days",
    "22 to 30 days",
    "31 to 60 days",
    "61 to 89 days",
    "90 to 179 days",
    "180 days or more"
  ];

// set up scales

//Position

const myGeoScaleDuration = createGeoScales(planningAreas.domain("$geometry"));

  // fill color
  const myColorScaleDuration = scaleOrdinal()
    .domain(planningAreas.domain("REGION_N"))
    .range(schemePastel2);

   //histogram

  const listingsByPropertyType = listingsDuration
    .groupBy('property_type')
    .summarise({ total_count: { id: "count" } });

  console.log(listingsByPropertyType)

  //selecting histogram to show on map
  let selectedHistoBar = ''
  let listingsSelection = listingsDuration

  function handleMouseoverHisto (event) {
    selectedHistoBar = event.key
  }

  function handleMouseoutHisto (event) {
    selectedHistoBar = ''
  }

  $: {
    if (selectedHistoBar === '') {
      listingsSelection = listingsDuration
    } else {
      listingsSelection = listingsDuration
        .filter(row => row.property_type === selectedHistoBar)
    }
  }


  // assignment of colors
  let colors = {
    "One week or less": "red",
    "8 to 14 days": "red",
    "15 to 21 days": "red",
    "22 to 30 days": "red",
    "31 to 60 days": "red",
    "61 to 89 days": "red",
    "90 to 179 days": "orange",
    "180 days or more": "green"
  };

</script>

<div class="Title">
<h1> Exploring Airbnb listings and identifying possible infringement of regulations in Singapore </h1>
<p> Angie Wong, Jeanette Choong, Tee Jia Xin </p>
</div>

<div class="Background">
<h2> Project Background </h2>
<p> Airbnb is becoming an increasingly common platform that tourists globally use to search for and book accommodation. This could be related to the broader trend of resisting mass tourism, which typically involves living in hotels located in tourist enclaves. 
Instead, tourists today are seeking for alternative ways to travel that are underpinned by stronger connections to local communities. However, the ability to experience such forms of tourism may be limited in countries where the government imposes strict regulations over hosts and guests of Airbnb, given the possible negative impacts this service may have on their citizens and urban environments. 
In particular, the Singaporean government imposes rather strict regulations on the type of homes that can qualify as Airbnb listings and the minimum length of stay of guests in each listing. Such rules were implemented due to concerns that Airbnb guests may cause disruption to public housing estates, where most Singaporeans live together in close proximity, as well as the impact that Airbnb may have on hotel businesses given that the Singapore economy depends greatly on tourism-related industries. 
</p>
<p>
Despite these strict regulations, it appears that Airbnb is becoming increasingly popular in Singapore, as seen from the interactive graph below, which depicts an expoential increase of Airbnb reviews from 2011 to 2020.
</p>

<select bind:value={selectedYear}>
		{#each reviewsYears as year}
     <!-- value extracted from dataset -->
			<option value={year}>
       <!-- actual content -->
				{year}
			</option>
		{/each}
	</select>

<div class="caption">
  {#if selectedBar === ''}
  <p> Hover over each bar and/or select a year to find out the number of Airbnb reviews in a particular month and year. </p>
  {:else}
  <p>The number of reviews in {selectedBarInfo.date_year_month} is {selectedBarInfo.count}. </p>
  {/if}
  </div>

<div class="graph">
  <div class="main-chart">
    <Graphic 
    width={600} 
    height={400} 
    scaleX={scaleTime().domain(reviews.domain("date"))} 
    scaleY={scaleLinear().domain([0, reviews.domain('count')[1]])} 
    flipY 
    {padding}
    >

      <RectangleLayer 
      x1={reviews.column('date')}
      x2={reviews.map('date', (value) => timeMonth.offset(value, 1))}
      y1={reviews.column('count')}
      y2={0}
      fill={colorBar}
      key={reviews.column('id')}
      onMouseover={handleMouseover}
      onMouseout={handleMouseout}
      /> 

      <XAxis title = "Date"/>
      <YAxis title = "Count"/>

    </Graphic>
  </div>
</div>

</div>

<div class="Objectives">
<h2> Project Objectives </h2>
<p> 
In light of such trends, this project seeks to present visualisations that would provide a better understanding of supply and demand trends related to Airbnb in Singapore based on data from March 2020.
Firstly, we seek to use graphical and spatial visualizations to communicate various patterns surrounding hosting and renting property on Airbnb, specifically on the spatial distribution of Airbnb listings across the different planning areas in Singapore.
Secondly, we also seek to provide visualizations that would allow our audience to explore the extent of adherence by Airbnb hosts with regards to restrictions imposed by the Singapore government. 
Specifically, this would be in reference to the regulation that requires Airbnb hosts to rent out their property for a minimum of 90 days for private properties, and a minimum of 180 days for public housing units. 
</p>
</div>

<div class="Spatial distribution">
<h2>Spatial distribution of Airbnb Listings across Singapore </h2>
<h3> Examining individual Airbnb Listings </h3>
<div class="Map showing listings as points">
<select bind:value={selectedTown}>
		{#each towns as town}
			<option value={town}>
        {town}
			</option>
		{/each}
	</select>

  <p> Select the town you are interested to examine and hover over each point for more information about the property and room type of a particular listing. </p> 
  
  <div class="main-chart" align>
   <Graphic 
    width={1000} 
    height={700}
    {...myGeoScale}
    flipY >

  <PolygonLayer 
        geometry={planningAreas.column('$geometry')}
        stroke={'white'}
        strokeWidth={1}
        fill={planningAreas.map('REGION_N', myColorScale)}
      />

{#each listings.rows() as row, i (row.$key)}   
      <Point
      geometry={row.$geometry}
      stroke={'grey'}
      strokeWidth={0.1}
      onMouseover={event => handleMouseoverPointListings(event, row)}
      onMouseout={event => handleMouseoutPointListings(event, row)}
      />
    {/each}

 {#if mousePosition !== undefined}
  <Rectangle
          x1={mousePosition.x + 1000}
          x2= {mousePosition.x + 12000}
          y1={mousePosition.y + 1000}
          y2= {mousePosition.y + 3000}
          fill={'#f2f2f2'}
          stroke={'black'}
          strokeWidth={0.5}
        />
   <Label
          x={mousePosition.x + 1500}
          y={mousePosition.y + 2500}
          anchorPoint={'l'}
          text={'  Property Type: ' + selectedListing.proptype}
        />

  <Label
          x={mousePosition.x + 1500}
          y={mousePosition.y + 1500}
          anchorPoint={'l'}
          text={'  Room Type: ' + selectedListing.roomtype}
        />
    {/if}

    <DiscreteLegend 
        title={'Regions'}
        fill={myColorScale}
        label={'Map Regions'}
        strokeWidth={2}
        stroke={'white'}
        orient={'vertical'}
        vjust={'top'}
        hjust={'right'}
        flipLabels
        labelPaddingX={-160}
        usePadding={true}
      />

    </Graphic>
  </div>
</div>

<h3> Exploring Airbnb Listings across Planning Areas in Singapore </h3>

<p> Apart from exploring individual Airbnb listings in Singapore, the map below also shows the disitrbution of listings across planning areas in Singapore. 
Specficially, the map shows the number of Airbnb listings in each planning area.
Darker coloured areas show that there are a greater number of listings than areas that are lighter coloured, while grey areas show planning areas that do not contain any listings. 
</p>

<p> As seen from the map, the Airbnb listings are are much higher in planning areas closest to the city centre, while planning areas without any Airbnb listings are found in more peripheral locations in Singapore.
This could be because planning areas nearer to the city centre have better access to amenities and transport networks, hence encourages more hosts to put up their properties as listings on Airbnb greater number of listings to capitalise on the high demand from Airbnb guests. 
</p> 

<p> Hover over each polygon to identify the planning area and the number of Airbnb listings in this area. </p>

<div class="main-chart">
<div class="Map showing aggregated data on listings across planning areas">
<Graphic 
    width={1000} 
    height={700}
    {...myGeoScaleArea}
    flipY >

    <PolygonLayer 
        geometry={listingsArea.column('$geometry')}
        stroke={'white'}
        strokeWidth={1} 
        fill={'#E0E0E0'}
      />
      <PolygonLayer 
        geometry={listingsAreaWithoutNull.column('$geometry')}
        stroke={'white'}
        strokeWidth={1} 
        fill={listingsAreaWithoutNull.map('num_listings', myColorScaleArea)}
      />

{#each listingsArea.rows() as row, i (row.$key)}   
      <Polygon
      geometry={row.$geometry}
      stroke={'black'}
      fill={'none'}
      strokeWidth={0.2}
      onMouseover={event => handleMouseoverArea(event, row)}
      onMouseout={event => handleMouseoutArea(event, row)}
      />
    {/each}

 {#if mousePositionArea !== undefined}
  <Rectangle
          x1={mousePositionArea.x + 1500}
          x2= {mousePositionArea.x + 19000}
          y1={mousePositionArea.y + 500}
          y2= {mousePositionArea.y + 2000}
          fill={'#f2f2f2'}
          stroke={'black'}
          strokeWidth={0.5}
        />
   <Label
          x={mousePositionArea.x + 1500}
          y={mousePositionArea.y + 1500}
          anchorPoint={'l'}
          text={selectedListingArea.planning_area + ' , ' + selectedListingArea.listings_number + ' Listings '}
        />
    {/if}

    {#if selectedListingArea.listings_number === null}
  <Rectangle
          x1={mousePositionArea.x + 1500}
          x2= {mousePositionArea.x + 19000}
          y1={mousePositionArea.y + 500}
          y2= {mousePositionArea.y + 2000}
          fill={'#f2f2f2'}
          stroke={'black'}
          strokeWidth={0.5}
        />
   <Label
          x={mousePositionArea.x + 1500}
          y={mousePositionArea.y + 1500}
          anchorPoint={'l'}
          text={selectedListingArea.planning_area}
        />
    {/if}

    <GradientLegend
    title={'Number of Listings'}
    fill={myColorScaleArea}
    labelCount={5}
    vjust={'top'}
    hjust={'right'}
    flip
  />

    </Graphic>

</div>
</div>
</div>

<div class="Infringement">
<h2> Airbnb listings based on property type and minimum length of stay stated by host </h2>
<p> According to Singapore's Planning Act, as well as the Housing and Development Act, airbnb hosts need to ensure that their guests stay for a minimum of 90 days. 
This visualisations in this section were created to to allow users to examine such trends and think of possible factors as to why they may occur despite the presence of regulations.  
</p>

<p> This map below charts shows the distribution of listings based on the minimum duration of stay that hosts in Singapore have stated on their Airbnb listings.
The red dots show listings that have did not adhere to the minimum 90day stay requirement, while the green dots show those that adhered to the regulation. 
The orange dots refer to listings that may or may not have violated this regulation, depending on whether they are private properties or units in public HDB flats. 
Listings in public HDB flats are governed by stricter regulations and require guests to minimally stay for 180 days. 
However, as the Airbnb data does not distinguish between listings located in private properties and public housing, whether this group of listings have violated the regulation remains ambiguous.
</p>

<p> The histogram next to the map shows the distribution across different property types.
Hover over the bars to examine how these listings are spatially distributed on the map, as well as the minimum length of stay indicated by hosts for these listings. 
</p> 

<p>Given that such data could be sensitive and could result in potential legal implications, it is important to note that we are not making any conclusions about hosts based on their adherence to these regulations.
Rather, these visualisations provide avenues for users to explore how any violations in regulations may or may not be justified in the context of Singapore.
For example, it is acceptable for hotels who post their listings on Airbnb to host guests for less than 90 days. 
Hovering over the bar 'hotels' will reveal a significant number of listings which stated a minimum stay of less than 90 days (depicted by red dots), which do not violate the regulation in this case. 
</p>

<div class="main-chart">
<Graphic width={1250} height={700}>
<Section 
  x1={0}
  x2={500}
  y1={0}
  y2={500}
  scaleX={scaleLinear().domain([0, listingsByPropertyType.domain('total_count')[1]])}
  scaleY={scaleBand().domain(listingsByPropertyType.domain('property_type')).padding(0.5)}
  padding={{left: 90, bottom: 30, top: 0, right: 10 }}
    >
    <RectangleLayer 
          x1={0}
          x2={listingsByPropertyType.column('total_count')}
          y1={listingsByPropertyType.column('property_type')}
          y2={({ scaleY }) => listingsByPropertyType.map('property_type', ft => scaleY(ft) + scaleY.bandwidth())}
          key={listingsByPropertyType.column('property_type')}
          onMouseover={handleMouseoverHisto}
          onMouseout={handleMouseoutHisto}
        />
        <XAxis labelFontSize={8} title="Count" />
        <YAxis labelFontSize={8} title="Property Type" />
  </Section>
  
  <Section
    x1={550}
    x2={1250}
    y1={0}
    y2={700}
    {...myGeoScaleDuration} 
    flipY>

      <PolygonLayer 
        geometry={planningAreas.column('$geometry')}
        stroke={'white'}
        strokeWidth={1} 
        fill={planningAreas.map('REGION_N', myColorScaleDuration)}
      />

      {#each listingsSelection.rows() as row, i (row.$key)}
      <Point
      geometry={row.$geometry}
      fill={colors[row.stated_min_duration]}
      />
      {/each}

    <DiscreteLegend 
        title={'Regions'}
        fill={myColorScaleDuration}
        label={'Map Regions'}
        strokeWidth={2}
        stroke={'white'}
        orient={'vertical'}
        vjust={'top'}
        hjust={'right'}
        flipLabels
        labelPaddingX={-160}
        usePadding={true}
      />

      </Section>
  </Graphic>

  </div>
  </div>

  <style>
  .main-chart {
    font-family: "Cormorant Garamond", serif;
    font-size: 6.5px;
  }

  select {
    font-family: "Cormorant Garamond", serif;
    font-size: 16px;
  }

  p {
    font-family: "Cormorant Garamond", serif;
    font-size: 16px;
  }

  </style>

